import __vue_component__$1 from './Select.vue.js';
import pDebounce_1 from '../../node_modules/p-debounce/index.js';
import __vue_component__ from '../field-renderers/UserRenderer.vue.js';

//
var script = {
  name: 'UserPicker',
  components: {
    UserRenderer: __vue_component__,
    Select: __vue_component__$1
  },
  props: {
    getUsers: {
      type: Function,
      required: true
    },
    value: {
      type: [Object, Array],
      default: undefined
    },
    multi: {
      type: Boolean,
      default: false
    },
    isFocused: {
      type: Boolean,
      default: false
    },
    mapper: {
      type: Function,
      default: list => list
    },
    placeholder: {
      type: String,
      default: 'Type to search...'
    },
    searchPromptText: {
      type: String,
      default: 'Type to search...'
    },
    initialOptions: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      users: [],
      isFetching: false,
      debouncedGetUsers: undefined
    };
  },

  created() {
    this.debouncedGetUsers = pDebounce_1(this.onSearchChange, 200);
  },

  methods: {
    loadInitialOptions() {
      this.users = this.initialOptions;
    },

    async onSearchChange(query) {
      if (!query) return;
      this.isFetching = true;
      const {
        data: users
      } = await this.getUsers(query);
      this.users = this.mapper(users);
      this.isFetching = false;
    },

    normalizer(user) {
      return {
        id: user.key,
        label: user.name,
        value: user,
        disabled: user.disabled
      };
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Select/UserPicker.vue_rollup-plugin-vue=script.js